import React from 'react'
import Header from '../Comman/Header'
import Footer from '../Comman/Footer'
import ResetPassword from './ResetPassword'

export default function Reset() {
    return (
        <>
            <Header />
            <ResetPassword />
            <Footer />
        </>
    )
}
